<template>
  <div class="c-article-detail__imagecontainer">
    <figure class="c-article-detail__image">
      <a :href="firstImageUrl" title="" data-fancybox-hero="" data-src="" data-srcset="">
        <img :src="firstImageUrl">
      </a>
    </figure>
    <div class="c-article-detail__thumbnails">
      <div class="c-article-detail__thumbnailcontainer">
        <a :href="firstImageUrl" title="CU-CHAIN-120: USB 2.0 Kabel PUR für Industrie u. Schleppkette, Typ A auf B, 12m" class="thumbnail--link is--active" data-fancybox-group="group" :data-src="firstImageUrl">
          <img :src="firstImageUrl"  alt="CU-CHAIN-120: USB 2.0 Kabel PUR für Industrie u. Schleppkette, Typ A auf B, 12m" title="CU-CHAIN-120: USB 2.0 Kabel PUR für Industrie u. Schleppkette, Typ A auf B, 12m" class="thumbnail--image">
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Gallery',
  props: {
    firstImageUrl: null
  }
}
</script>

<style scoped lang="sass">
  .c-article-detail__imagecontainer
    //@include span-columns(5)

    .c-article-detail__image
      margin: 0em
      height: 22.5em
      width: 22.5em
      border: 2px solid #f8f8f8
      border-radius: $border-radius
      overflow: hidden
      display: flex
      align-items: center
      a
        width: 100%
        height: 100%
      img
        height: auto
        width: 100%
        border-radius: $border-radius

    .c-article-detail__thumbnails
      padding-top: 0.5em
      .c-article-detail__thumbnailcontainer
        width: 23em
        img
          width: 4em
          border: 1px solid $light-grey
          border-radius: $border-radius
        a
          margin-right: 0.25em

      .image-slider--container
        display: none
</style>
